module.exports = __webpack_public_path__ + "static/media/MARC.34d0776f.pdf";